import React from 'react';
import {Map} from 'immutable';
import {lightRedBackground} from './Bootflow';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {
  CART_STATES,
  DATA_ATTR_NODE_TYPE,
  NODE_TYPE_COMMERCE_CART_ERROR,
} from '@packages/systems/commerce/constants';
import {
  Environment,
  WebflowEnvironments,
} from '@packages/systems/core-constants';

import {Atom} from '@packages/systems/wfdl';
import {TListOfElement, TRecord, TText} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {useRuntimeEnvironment} from '@packages/systems/render';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const styleDisplayNone = Map({style: Map({display: 'none'})});

const shouldThisComponentBeShown = ({
  runtimeEnvironment,
  tempState,
}: {
  runtimeEnvironment: Environment;
  tempState: unknown;
}) => {
  const isDesigner = runtimeEnvironment === WebflowEnvironments.DESIGNER;

  if (isDesigner) {
    return tempState === CART_STATES.ERROR;
  }
  return false;
};

const CommerceCartErrorState = Atom.createRender((props) => {
  const {attributes, classes, context, data, generateAttributes, renderChild} =
    props;

  const runtimeEnvironment = useRuntimeEnvironment();
  const tempState = context.get('tempState');

  const styledAttributes = shouldThisComponentBeShown({
    runtimeEnvironment,
    tempState,
  })
    ? attributes
    : attributes.merge(styleDisplayNone);
  const attributesWithType = styledAttributes.set(
    DATA_ATTR_NODE_TYPE,
    NODE_TYPE_COMMERCE_CART_ERROR
  );
  return (
    <div {...generateAttributes(attributesWithType, classes)}>
      {getChildren(data).map((child: EvaluatedNodeData) => renderChild(child))}
    </div>
  );
});

const config = createIntegratedAtom({
  displayName: 'Error State',
  showEmpty: true,
  constraints: {
    pinToParent: true,
    descendants: [{is: 'CommerceCartErrorMsg', rule: 'ExactlyOne'}],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          marginTop: px(0),
          marginRight: px(24),
          marginBottom: px(24),
          marginLeft: px(24),
          paddingTop: px(10),
          paddingRight: px(10),
          paddingBottom: px(10),
          paddingLeft: px(10),
          flexGrow: 0,
          flexShrink: 0,
          flexBasis: 'auto',
          backgroundColor: lightRedBackground,
        },
      },
    },
  },
  render: CommerceCartErrorState,
  fields: {children: TListOfElement, attr: TRecord({'aria-live': TText})},
});

export default config;
